// extracted by mini-css-extract-plugin
export default {"styles":"styles___X9tLi","userList":"userList___QKlh4","card":"card___DN3i1","avatar":"avatar___KQnDA","resourceStyles":"resourceStyles___SEtmJ","Content":"Content___wDk3w"};